"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].ServerInsertedHtml;

//# sourceMappingURL=server-inserted-html.js.map